import { isEmpty } from 'lodash-es';
import { useEffect, useRef } from 'react';

import type {
  OffsetPageResponseMyChallengeVoucherDto,
  OffsetPageResponseMyVoucherDto,
} from '../../../../../../resources/@types/courseSchema';
import { useTrackMixpanelEvent } from '../../../../../utils/GTM/useTrackMixpanelEvent';
import type { StringifyObject } from '../../../../../utils/typeUtil';
import type { VoucherMyQueryParameter } from '../queries/useClientApiVoucherMyQuery';
import useUrlStateForMyCourses from './useUrlStateForMyCourses';

export function useMyCoursesSearchEvent({
  myVoucher,
  filterValue,
  isSearching,
}: {
  myVoucher?: OffsetPageResponseMyVoucherDto | OffsetPageResponseMyChallengeVoucherDto;
  filterValue: StringifyObject<VoucherMyQueryParameter>;
  isSearching: boolean;
}) {
  const { trackMixpanelEvent } = useTrackMixpanelEvent();
  const { getCurrentFilterForGTM, getSortLabelForGTM } = useUrlStateForMyCourses();

  const prevSearchKeyword = useRef('');

  useEffect(() => {
    if (
      isSearching ||
      isEmpty(filterValue.searchKeyword) ||
      prevSearchKeyword.current === filterValue.searchKeyword
    ) {
      return;
    }

    const { isReviewable, studying } = getCurrentFilterForGTM();
    const data = {
      search_keyword: filterValue.searchKeyword,
      sorting_my_courses: getSortLabelForGTM(),
      filter_my_courses: [studying, isReviewable].filter(Boolean),
      course_count: (myVoucher?.items || []).length,
      course_identification: (myVoucher?.items || []).map((voucher) => voucher.course.id),
    };

    trackMixpanelEvent('search_my_courses', data);
    prevSearchKeyword.current = filterValue.searchKeyword || '';
  }, [isSearching, filterValue.searchKeyword]);
}
